import { useState, useEffect } from "react";
import { userAPI } from "../services/api";

export const useUser = () => {
  const [user, setUser] = useState(null);
  const [limits, setLimits] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUser = async () => {
    try {
      setLoading(true);
      const response = await userAPI.getProfile();
      setUser(response.data.user);
      setLimits(response.data.limits);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error("Ошибка загрузки профиля:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return { user, limits, loading, error, refetch: fetchUser };
};
